export type Collection = any;

export function flattenCollection<T>(collection: Collection): T[] {
  if (collection == undefined)
    return [];
    
  let result: T[] = [];
  if (collection != undefined) {
    const map: Map<string, any> = new Map(Object.entries(collection))
    map.forEach((value, id) => result.push({ ...value, id: id }));
  }
  return result;
}